class VacationsAbsencesService {

  constructor(
    vacationUserDataService,
    vacationInitialDataService,
    vacationInitialDataManagerService,
    teamRequestsService,
    vacationTeamRequestDataService,
    ManagerDataService,
    $log
  ) {
    'ngInject';
    this.initialDataService = vacationInitialDataService;
    this.ManagerDataService = ManagerDataService;
    this.userDataService = vacationUserDataService;
    this.initialDataManagerService = vacationInitialDataManagerService;
    this.teamRequestsService = teamRequestsService;
    this.TeamRequestDataService = vacationTeamRequestDataService;
    this.loaded = false;
    this.manager = false;
    this.log = $log;
  }

  loadData() {
    if (!this.userDataService.isEmpty()) {
      return;
    }

    this.initialDataService.initMainData().then((employee) => {
      if (!employee) return;
      this.employee = employee;
      this.manager = employee.isManager();
      this.hasDelegation = employee.hasDelegation();
      if (this.manager || this.hasDelegation) {
        this._loadManagerData();
        this._loadTeamRequestData();
      }
      else {
        this.loaded = true;
      }
      return employee;
    }, (err) => {
      this.employee = {};
      this.manager = false;
      throw(err);
    });
  }

  _loadManagerData() {
    if (!this.ManagerDataService.isEmpty()) {
      return;
    }

    this.initialDataManagerService.initMainData().then((manager) => {
      if (!manager) return;
      this.managerData = manager;
      return manager;
    }, (err) => {
      this.managerData = {};
      throw(err);
    });
  }

  _loadTeamRequestData() {
    const managerId = this.userDataService.getEmployee().userId;
    let nextId = 0;
    return this.teamRequestsService.getRequests(managerId).then((data) => {
      this.loaded = true;
      this.log.info('teamRequestsService.getRequests:', managerId, data);
      let requests = data.requestPeriods;
      requests.forEach((request) => request._id = nextId++);
      this.TeamRequestDataService.setData(requests);
    })
    .catch((error) => {
      this.log.error('teamRequestsService.getRequests:', managerId, error);
    });
  }

}

export default VacationsAbsencesService;



// WEBPACK FOOTER //
// ./client/app/vacations-absences.module/vacations-absences.service.js